import { atomWithHash } from "jotai/utils";

let mttFinancialAnalysisToolStrings = window["mttFinancialAnalysisToolStrings"];
export let topbar_projectname_label =
  mttFinancialAnalysisToolStrings.topbar_projectname_label ?? "Summary:";
export let topbar_goal_label =
  mttFinancialAnalysisToolStrings.topbar_goal_label ?? "Goal:";
export let topbar_period_label =
  mttFinancialAnalysisToolStrings.topbar_period_label ?? "Period:";
export let topbar_income_label =
  mttFinancialAnalysisToolStrings.topbar_income_label ?? "Income:";
export let topbar_expenses_label =
  mttFinancialAnalysisToolStrings.topbar_expenses_label ?? "Expenses:";

export let tooltip_totalmembers_label =
  mttFinancialAnalysisToolStrings.stepresult_graph?.tooltip
    ?.totalmembers_label ?? "Total members";
export let tooltip_newmembers_label =
  mttFinancialAnalysisToolStrings?.stepresult_graph?.tooltip
    ?.newmembers_label ?? "New members";
export let tooltip_fee_label =
  mttFinancialAnalysisToolStrings?.stepresult_graph?.tooltip?.fee_label ??
  "Member fee";
export let tooltip_missingincome_label =
  mttFinancialAnalysisToolStrings.stepresult_graph?.tooltip
    ?.missingincome_label ?? "Missing Income";

export let legend_projected_label =
  mttFinancialAnalysisToolStrings?.stepresult_graph?.legend?.projected_label ??
  "Projected";
export let legend_goal_label =
  mttFinancialAnalysisToolStrings?.stepresult_graph?.legend?.goal_label ??
  "Goal";
export let legend_unchanged_label =
  mttFinancialAnalysisToolStrings?.stepresult_graph?.legend?.unchanged_label ??
  "Unchanged";

export let stepresult_overtitle =
  mttFinancialAnalysisToolStrings?.stepresult_overtitle ?? "Graph";
export let stepresult_title =
  mttFinancialAnalysisToolStrings?.stepresult_title ?? "Result";
export let resultheader_goalreached_label =
  mttFinancialAnalysisToolStrings?.stepresult_resultheader?.goalreached_label ??
  "Goal Reached";
export let resultheader_goalnotreached_label =
  mttFinancialAnalysisToolStrings?.stepresult_resultheader
    ?.goalnotreached_label ?? "Goal Not Reached";
export let resultheader_missingincome_label =
  mttFinancialAnalysisToolStrings?.stepresult_resultheader
    ?.missingincome_label ?? "Missing Income";
export let resultheader_periodspan_label =
  mttFinancialAnalysisToolStrings?.stepresult_resultheader?.periodspan_label ??
  "Period length";
export let resultheader_year_text =
  mttFinancialAnalysisToolStrings?.stepresult_resultheader?.year_texts
    ?.singular ?? "year";
export let resultheader_years_text =
  mttFinancialAnalysisToolStrings?.stepresult_resultheader?.year_texts
    ?.plural ?? "years";

export let sidebar_members_label =
  mttFinancialAnalysisToolStrings?.stepresult_graph?.sidebar?.membercount
    ?.initial_label ?? "Member count";
export let sidebar_totalcount_label =
  mttFinancialAnalysisToolStrings?.stepresult_graph?.sidebar?.membercount
    ?.total_label ?? "Total members";
export let sidebar_increasecount_label =
  mttFinancialAnalysisToolStrings?.stepresult_graph?.sidebar?.membercount
    ?.increase_total_label ?? "Members increase";
export let sidebar_membercount_increasepersent_label =
  mttFinancialAnalysisToolStrings?.stepresult_graph?.sidebar?.membercount
    ?.increase_percent_label ?? "Percentage increase";

export let sidebar_memberfee_increasepersent_label =
  mttFinancialAnalysisToolStrings?.stepresult_graph?.sidebar?.memberfee
    ?.increase_percent_label ?? "Percentage increase";
export let sidebar_fee_label =
  mttFinancialAnalysisToolStrings?.stepresult_graph?.sidebar?.memberfee
    ?.initial_label ?? "Member fee";
export let sidebar_feeincrease_label =
  mttFinancialAnalysisToolStrings?.stepresult_graph?.sidebar?.memberfee
    ?.increase_total_label ?? "Member fee increase";
export let sidebar_totalfee_label =
  mttFinancialAnalysisToolStrings?.stepresult_graph?.sidebar?.memberfee
    .total_label ?? "Total member fee";

export let step1_title =
  mttFinancialAnalysisToolStrings.step1_title ?? "General information";
export let step1_intro =
  mttFinancialAnalysisToolStrings.step1_intro ??
  "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.";

export let step4_title =
  mttFinancialAnalysisToolStrings.step4_title ?? "General information";
export let step4_goal_title =
  mttFinancialAnalysisToolStrings.step4_goal_title ?? "General information";
export let step4_intro =
  mttFinancialAnalysisToolStrings.step4_intro ??
  "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.";
export let step4_bottom_text =
  mttFinancialAnalysisToolStrings.step4_bottom_text ?? "";
export let step2_bottom_text =
  mttFinancialAnalysisToolStrings.step2_bottom_text ?? "";

export let step1_projectname_label =
  mttFinancialAnalysisToolStrings.step1_projectname_label ?? "Project Name";
export let step1_period_label =
  mttFinancialAnalysisToolStrings.step1_period_label ?? "Project Start/End";
export let step1_goal_label =
  mttFinancialAnalysisToolStrings.step1_goal_label ?? "Overall economic goal";
export let back_string = mttFinancialAnalysisToolStrings.back_string ?? "Back";
export let next_string = mttFinancialAnalysisToolStrings.next_string ?? "Next";

export let step2_title =
  mttFinancialAnalysisToolStrings.step2_title ?? "Current income";
export let step2_intro =
  mttFinancialAnalysisToolStrings.step2_intro ??
  "Note: aid is not an income, provide the number of members and how much they pay in yearly member fees";
export let step2_membercount_label =
  mttFinancialAnalysisToolStrings.step2_membercount?.label ?? "Members";
export let step2_membercount = mttFinancialAnalysisToolStrings?.step2_membercount ?? {
  label: "Members",
  description: "Members",
  tootip: "tooltip"
};
export let step2_feepermember_label =
  mttFinancialAnalysisToolStrings?.step2_feepermember_label ??
  "Memberfee per member";
export let step2_feeperyear_label =
  mttFinancialAnalysisToolStrings?.step2_feeperyear_label ??
  "Memberfee per year";
export let step2_feeperyear = mttFinancialAnalysisToolStrings?.step2_feeperyear ?? {
  label: "Memberfee per member",
  description: "Memberfee per year",
  tootip: "tooltip"
};
export let step2_addextra_string =
  mttFinancialAnalysisToolStrings?.step2_addextra_string ?? "Add extra income";

export let step1_addextra_string =
  mttFinancialAnalysisToolStrings?.step1_addextra_string ?? "Add extra goal";

export let step3_title =
  mttFinancialAnalysisToolStrings?.step3_title ?? "Current expenses";
export let step3_intro =
  mttFinancialAnalysisToolStrings?.step3_intro ??
  "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.";
export let step3_addextra_string =
  mttFinancialAnalysisToolStrings.step3_addextra_string ?? "Add extra expense";

export let print_string =
  mttFinancialAnalysisToolStrings.print_string ?? "Print";

export let step3_predefinedxpenses =
  mttFinancialAnalysisToolStrings.step3_predefinedxpenses?.map?.(f => ({
    atom: atomWithHash(`expenses_${f?.label}` ?? "officeRent1", 0),
    title: f?.label ?? "kontorudgifter",
    text: f?.description ?? "Office Rent",
    tooltip: f?.tooltip ?? "Office Rent"
  })) ?? [];

export let step1_predefinedgoals =
  mttFinancialAnalysisToolStrings.step1_predefinedgoals?.map?.(f => ({
    atom: atomWithHash(`goals_${f?.label}` ?? "officeRent2", 0),
    title: f?.label ?? "kontorudgifter",
    text: f?.description ?? "Office Rent",
    tooltip: f?.tooltip ?? "Office Rent"
  })) ?? [];

export let table_time_header =
  mttFinancialAnalysisToolStrings.table_time_header ?? "Tidspunkt";
export let table_membercount_header =
  mttFinancialAnalysisToolStrings.table_membercount_header ??
  "Total antal medlemmer";
export let table_newmembers_header =
  mttFinancialAnalysisToolStrings.table_newmembers_header ?? "Nye medlemmer";
export let table_fee_header =
  mttFinancialAnalysisToolStrings.table_fee_header ?? "Kontingent";
